import { call, put, takeLatest } from "redux-saga/effects";
import {
  deleteOrderIdSuccess,
  saveOrderActionSuccess,
  editOrderIdSuccess,
  updateOrderIdSuccess,
  getOrderListPageSuccess,
  GoButton_For_Order_AddSuccess,
  orderApprovalActionSuccess,
  getOrderApprovalDetailActionSucc,
  orderApiErrorAction,
  postOrderConfirms_API_Success,
  orderSinglegetSuccess,
  Order_Items_Success,
  Add_Order_Items_Success,
  ManuallyOrderCloseSuccess,
  orderAccountingApprovalActionSuccess,
} from "./actions";
import {
  OrderPage_Update_API,
  OrderPage_Delete_API,
  OrderPage_Save_API_ForPO,
  OrderPage_GoButton_API,
  OrderList_get_Filter_API,
  IBOrderPage_GoButton_API,
  IBOrderList_get_Filter_API,
  GRN_STP_for_orderList_goBtn,
  IBOrderPage_Save_API,
  orderApproval_Save_API,
  OrderPage_Edit_Get_API,
  OrderPage_Edit_Post_API,
  OrderConfirm_post_API,
  OrderPage_Edit_ForDownload_API,
  InterBranch_Order_Delete_API,
  IB_Order_Update_API,
  IB_Order_Get_Api,
  order_Single_and_Multiple_Print_API,
  Order_Items_API,
  Add_Order_Items_API,
  OrderPage_OptimizeGoButton_API,
  ManuallyOrderClose_API,
  OrderAccountingApprovalAPI,
} from "../../../helpers/backend_helper";
import {
  UPDATE_ORDER_ID_FROM_ORDER_PAGE,
  EDIT_ORDER_FOR_ORDER_PAGE,
  DELETE_ORDER_FOR_ORDER_PAGE,
  GO_BUTTON_FOR_ORDER_PAGE,
  SAVE_ORDER_FROM_ORDER_PAGE,
  GET_ORDER_LIST_PAGE,
  ORDER_APPROVAL_ACTION,
  GET_ORDER_APPROVAL_DETAIL,
  POST_ORDER_CONFIRM_API,
  ORDER_SINGLE_GET_API,
  ORDER_ITEMS,
  ADD_ORDER_ITEMS,
  MANUALLY_ORDER_CLOSE,
  ORDER_ACCOUNTING_APPROVAL
} from "./actionType";
import { amountCommaSeparateFunc, listpageConcatDateAndTime, date_dmy_func, loginSystemSetting, IsSweetAndSnacksCompany, loginCompanyID, loginUserIsFranchisesRole, convertTimefunc, loginUserDetails, isRACompany, loginPartyID, getOrderVisibilitySetting } from "../../../components/Common/CommonFunction";
import *as url from "../../../routes/route_url"



const CheckRateFromCompany = () => {
  const checkRateFromCompany = loginSystemSetting().MRP_Rate
  const loginCompanyId = IsSweetAndSnacksCompany() ? loginCompanyID() : "";
  const result = checkRateFromCompany
    .split(',')
    .map((part) => part.split('-')[0])
    .join(',');
  const isRateForSweetAndSnacksCompany = result.split(',').includes(loginCompanyId.toString());
  return { result, isRateForSweetAndSnacksCompany };
};




function* goButtonGenFunc({ config }) {                     // GO-Botton order Add Page by subPageMode  

  try {

    const { subPageMode, } = config
    let response;
    if ((subPageMode === url.ORDER_1) || (subPageMode === url.ORDER_2) || (subPageMode === url.ORDER_4) || (subPageMode === url.IB_ORDER) || (subPageMode === url.IB_SALES_ORDER) || (subPageMode === url.ORDER_QUATATION)) {

      const OptimizePartyTypes =
        loginSystemSetting()?.EnableOptimizeOrderapi || "";
      const allowedPartyTypes = OptimizePartyTypes
        .split(",")
        .map(id => Number(id.trim()));

      const isallowforoptimizeview = allowedPartyTypes.includes(loginUserDetails().PartyTypeID);
      if (isallowforoptimizeview) {
        response = yield call(OrderPage_OptimizeGoButton_API, config);
      } else {
        response = yield call(OrderPage_GoButton_API, config);
      }

      // GO-Botton Purchase Order 1 && 2 Add Page API
      yield response.Data.OrderItems.forEach((ele, k) => {
        ele["id"] = k + 1
        ele.UnitDetails = ele.UnitDetails.map(unit => ({
          ...unit,
          _BaseUnitRate: (unit.Rate * unit.BaseUnitQuantity)  /// this field add only for testing purpose ///checking  not use any where in code only for observation
        }))
        const isRateForSweetAndSnacksCompany = CheckRateFromCompany().isRateForSweetAndSnacksCompany;

        if ((subPageMode === url.ORDER_4) && loginUserIsFranchisesRole()) {
          // ele.Rate = Number(ele.MRPValue)

          ele.Rate = parseFloat((Number(ele.MRPValue) * 100 / (100 + Number(ele.GSTPercentage))).toFixed(2))
          ele.UnitDetails = ele.UnitDetails.map(unit => ({
            ...unit, Rate: parseFloat((Number(ele.MRPValue) * 100 / (100 + Number(ele.GSTPercentage))).toFixed(2)),
          }))

        }

        if ((subPageMode === url.ORDER_1) || (subPageMode === url.IB_ORDER) || isRateForSweetAndSnacksCompany) {
          ele.Rate = Number(ele.VRate)
          ele.UnitDetails = ele.UnitDetails.map(unit => ({
            ...unit, Rate: Number(ele.VRate),
          }))

        }
      });
      const termArr = []
      var term = response.Data.TermsAndConditions
      yield term.forEach((ele, k) => {
        termArr.push({
          value: ele.id,
          label: ele.TermsAndCondition,
          IsDeleted: 0
        })
      });

      yield response.Data.TermsAndConditions = termArr;
    }

    yield put(GoButton_For_Order_AddSuccess(response.Data));
  } catch (error) {
    yield put(orderApiErrorAction())
  }
}


function* OrderItems_GenFunc({ config }) {
  try {

    let response = yield call(Order_Items_API, config);
    yield put(Order_Items_Success(response.Data.OrderItems));
  } catch (error) {
    yield put(orderApiErrorAction())
  }
}


function* AddOrderItems_GenFunc({ config }) {
  const { subPageMode, } = config

  try {
    let response = yield call(Add_Order_Items_API, config);
    yield response.Data.OrderItems.forEach((ele, k) => {
      ele["id"] = k + 1
      ele.UnitDetails = ele.UnitDetails.map(unit => ({
        ...unit,
        _BaseUnitRate: (unit.Rate * unit.BaseUnitQuantity)  /// this field add only for testing purpose ///checking  not use any where in code only for observation
      }))
      if ((subPageMode === url.ORDER_4) && loginUserIsFranchisesRole()) {
        ele.Rate = parseFloat((Number(ele.MRPValue) * 100 / (100 + Number(ele.GSTPercentage))).toFixed(2))
        ele.UnitDetails = ele.UnitDetails.map(unit => ({
          ...unit, Rate: parseFloat((Number(ele.MRPValue) * 100 / (100 + Number(ele.GSTPercentage))).toFixed(2)),
        }))

      }
    })
    yield put(Add_Order_Items_Success(response.Data));
  } catch (error) {
    yield put(orderApiErrorAction())
  }
}




function* saveOrder_GenFunc({ config }) {

  const { subPageMode, btnId, jsonBody, gotoInvoiceMode } = config;

  let newConfig = config;
  // **************************************** for aorde Sap aproval********************************
  if (subPageMode === url.ORDER_2) {
    newConfig = { jsonBody, btnId: undefined }
  }
  // ********************************************************

  let response = {}
  try {
    if (subPageMode === url.IB_ORDER || subPageMode === url.IB_SALES_ORDER) {                   // Save  Order  Add Page by subPageMode 
      response = yield call(IBOrderPage_Save_API, newConfig);
    } else {
      response = yield call(OrderPage_Save_API_ForPO, config);
      response["btnId"] = btnId
      response["gotoInvoiceMode"] = gotoInvoiceMode
    }
    yield put(saveOrderActionSuccess(response));
  } catch (error) {
    yield put(orderApiErrorAction())
  }
}



function* editOrderGenFunc({ config }) {     //  Edit Order by subPageModede

  const { btnmode, btnId, subPageMode } = config;

  try {
    const isRateForSweetAndSnacksCompany = CheckRateFromCompany().isRateForSweetAndSnacksCompany;
    // let response = yield call(OrderPage_Edit_Post_API, config);
    let response;

    const OptimizePartyTypes =
        loginSystemSetting()?.EnableOptimizeOrderapi || "";
      const allowedPartyTypes = OptimizePartyTypes
        .split(",")
        .map(id => Number(id.trim()));

      const isallowforoptimizeview = allowedPartyTypes.includes(loginUserDetails().PartyTypeID);
      if (isallowforoptimizeview) {
        response = yield call(OrderPage_OptimizeGoButton_API, config);
      } else {
        response = yield call(OrderPage_GoButton_API, config);
      }

    if ((subPageMode === url.ORDER_LIST_1) || (subPageMode === url.IB_ORDER_PO_LIST) || isRateForSweetAndSnacksCompany) {
      response.Data.OrderItems.forEach((ele, k) => {

        // if ((subPageMode === url.ORDER_4) && loginUserIsFranchisesRole()) {
        //   ele.Rate = Number(ele.MRPValue)
        //   ele.UnitDetails = ele.UnitDetails.map(unit => ({
        //     ...unit, Rate: Number(ele.MRPValue),
        //   }))
        // } else {
        const SaveUnitdetail = ele.UnitDetails.find(
          unit => unit.UnitID === ele.Unit_id
        );
        if (SaveUnitdetail) {
          ele.Rate = ((SaveUnitdetail.BaseUnitQuantity / SaveUnitdetail.BaseUnitQuantityNoUnit) * Number(ele.VRate)).toFixed(2);
        } else {
          ele.Rate = Number(ele.VRate);
        }
        ele.UnitDetails = ele.UnitDetails.map(unit => ({
          ...unit, Rate: Number(ele.VRate),
        }))
        // }
      })
    }

    response.pageMode = btnmode
    response.btnId = btnId
    yield put(editOrderIdSuccess(response));
  } catch (error) {
    yield put(orderApiErrorAction())
  }
}

function* DeleteOrder_GenFunc({ config }) {
  // Delete Order by subPageMode
  try {
    let response = ""
    if (config.subPageMode === url.IB_ORDER_PO_LIST || config.subPageMode === url.IB_ORDER_SO_LIST) {
      response = yield call(InterBranch_Order_Delete_API, config);
    } else {
      response = yield call(OrderPage_Delete_API, config);
    }


    yield put(deleteOrderIdSuccess(response));
  } catch (error) {
    yield put(orderApiErrorAction())
  }
}

function* UpdateOrder_ID_GenFunc({ config }) {         // Update Order by subPageMode

  try {
    let response = ""
    if (config.subPageMode === url.IB_ORDER) {
      response = yield call(IB_Order_Update_API, config);
    } else {
      response = yield call(OrderPage_Update_API, config);
    }

    yield put(updateOrderIdSuccess(response))
  } catch (error) {
    yield put(orderApiErrorAction())
  }
}


function* orderList_GoBtn_GenFunc({ config }) {




  //  Order List Filter by subPageMode
  const isSweetAndSnacksCompany = IsSweetAndSnacksCompany()
  const loginsystemsetting = loginSystemSetting()
  const showChallanStatus = Number(loginsystemsetting?.ShowChallanOnSalesOrder) === 1;
  try {
    const hasRole = (role) => config?.userAccess[role];
    const { subPageMode } = config
    let response;
    let newList;

    if ((subPageMode === url.ORDER_LIST_1) || (subPageMode === url.ORDER_LIST_2) || (subPageMode === url.ORDER_LIST_4) || (subPageMode === url.APP_ORDER_LIST) || (subPageMode === url.ORDER_APPROVAL)) {
      response = yield call(OrderList_get_Filter_API, config); // GO-Botton Purchase Order 1 && 2 Add Page API
    }
    else if ((subPageMode === url.GRN_STP_1) || subPageMode === url.GRN_STP_3) {

      response = yield call(GRN_STP_for_orderList_goBtn, config); // GO-Botton IB-invoice Add Page API

    }
    else if ((subPageMode === url.IB_ORDER_PO_LIST) || (subPageMode === url.IB_ORDER_SO_LIST) || (subPageMode === url.IB_INVOICE_STP)) {
      response = yield call(IBOrderList_get_Filter_API, config); // GO-Botton IB-invoice Add Page API
    }

    newList = yield response.Data.map((i) => {

      i["recordsAmountTotal"] = i.OrderAmount;  // Breadcrumb Count total
      i.OrderAmount = amountCommaSeparateFunc(i.OrderAmount) //  GrandTotal show with commas
      var DeliveryDate = date_dmy_func(i.DeliveryDate);

      i.dashboardOrderDate = date_dmy_func(i.OrderDate); // Only for Dashoard 
      // //tranzaction date is only for fiterand page field but UI show transactionDateLabel

      const Inward = Number(i.Inward);
      const DateAndTimeLable = listpageConcatDateAndTime(i.OrderDate, i.CreatedOn);
      i["transactionDate"] = `${i.CreatedOn}${DateAndTimeLable}`; // transactionDate for sorting and filtering data 
      i["transactionDateLabel"] = DateAndTimeLable;

      i.DeliveryDate = (`${DeliveryDate}`)

      i.forceEditHide = false;
      i.forceMakeBtnHide = true;
      i.forceDeleteHide = false;
      i.forceSelectDissabled = false;
      i.forceHideOrderAprovalBtn = true;
      i.ExtraSelect = false;
      i.forceMakeChallanDisabled = false;
      i.forceMakeChallanHide = false;


      if (i.Inward > 0) {

        i.Inward = "Close"
        i.Status = "Close"
        i.forceEditHide = true

      } else {
        i.Status = "Open";
        i.Inward = "Open";
        if ((subPageMode === url.ORDER_LIST_4) && (isSweetAndSnacksCompany)) {
          i.forceExtraSelectDissabled = true;
        }
        if (subPageMode === url.GRN_STP_1 || (subPageMode === url.ORDER_LIST_1) || (subPageMode === url.IB_ORDER_SO_LIST) || (subPageMode === url.GRN_STP_3) || (subPageMode === url.IB_ORDER_PO_LIST)) {
          if ((subPageMode === url.IB_ORDER_SO_LIST || subPageMode === url.IB_ORDER_PO_LIST) && i.InvoiceCreated) {
            i.forceEditHide = true;
            i.forceMakeBtnHide = true
            i.forceDeleteHide = true;
          } else {
            i.forceMakeBtnHide = false
          }
        }
      }


      //+++++++++++++++++++++++++  Status colonm show Status   ++++++++++++++++++++++++++++++++++++++
      // if (i.SAPResponse) {
      //   i.SAPStatus = "Order send To SAP"
      // }

      // if (i.InvoiceCreated === true) {
      //   i.Status = "Invoice Created"
      //   if ((subPageMode === url.ORDER_LIST_4) && (isSweetAndSnacksCompany)) {
      //     i.forceMakeBtnHide = false

      //     i.forceExtraSelectDissabled = true;
      //   }
      // }
      // else if (i.IsConfirm === true) {
      //   i.Status = "Order Confirm"
      //   if ((subPageMode === url.ORDER_LIST_4) && (isSweetAndSnacksCompany)) {
      //     i.forceExtraSelectDissabled = false;;
      //   }


      // }


      //+++++++++++++++++++++++++  Status colonm show Status   ++++++++++++++++++++++++++++++++++++++
      if (i.SAPResponse) {
        i.SAPStatus = "Order send To SAP"
      }

      if (i.InvoiceDeleted === true) {                     //  New Flag Logic
        i.Status = "Invoice Deleted";
      } else if (i.InvoiceCreated === true) {
        i.Status = "Invoice Created"
        if ((subPageMode === url.ORDER_LIST_4) && (isSweetAndSnacksCompany)) {
          if (i?.IsOrderClose) {
            i.forceMakeBtnHide = true;
            i.forceExtraSelectDissabled = true;
          } else {
            i.forceMakeBtnHide = false;
            i.forceExtraSelectDissabled = false;
          }
        }
      }
      else if (i.IsConfirm === true) {
        i.Status = "Order Confirm"
        if ((subPageMode === url.ORDER_LIST_4) && (isSweetAndSnacksCompany)) {
          i.forceExtraSelectDissabled = false;
        }
      }

      //**********************************order Aproval button Show Condition ********************************************************** */

      if (!i.SAPResponse && i.CustomerSAPCode) {//order Aproval button Show Condition 

        // i.forceHideOrderAprovalBtn = false;

        if (i.SupplierSAPCode) {             //if   SupplierSAPCode not there then user not allow to 
          i.forceHideOrderAprovalBtn = false;
        } else {
          i.forceHideOrderAprovalBtn = true;
        }

        if (hasRole("RoleAccess_SendToSAP")) {  //if RoleAccess_SendToSAP then only all select aplicable access not then not aplical

          i.forceSelectDissabled = true;
        } else {
          i.forceSelectDissabled = false;
        }
      }



      //++++++++++++++++++++++++++++++++++++++ make invoice Button dessiable/vissbble ++++++++++++++++++++++++++++++++++++++
      if (!(i.InvoiceCreated === true) && (i.IsConfirm === true)) {
        i.forceMakeBtnHide = false
      }



      //**********************************order Aproval button Show Condition ********************************************************** */

      if (i.IsConfirm === true) {
        i.forceEditHide = true;
        i.forceDeleteHide = true;
        i.forceSelectDissabled = true;
        if (subPageMode === url.APP_ORDER_LIST) {
          if (!(i.SubPartyFlag) || (i.InvoiceCreated)) {
            i.forceSelectDissabled = true;
            if (i.InvoiceCreated) {
              i.forceSelectDissabled = true;
            }
          } else {
            i.forceSelectDissabled = false
          }
        } else if (subPageMode === url.ORDER_APPROVAL) {
          i.forceSelectDissabled = (i.IsAccountingApproved === true || i.IsOrderClose); // only disable once already approved
        }
      }

      //**********sap_code order page********************************************************************************************
      if (i.SAPResponse) {  //If sapcode true the edit and delete btn  dissbale

        var numb = i.SAPResponse.match(/\d/g);
        i.SAPResponse = numb.join("");
        if (subPageMode === url.ORDER_LIST_4) { i.SONumberFull = `${i.SONumberFull} (${i.SAPResponse})` }
        else { i.PONumberFull = `${i.PONumberFull} (${i.SAPResponse})` }//concate sap code and full order number
        i.forceEditHide = true
        i.forceDeleteHide = true

        i.forceHideOrderAprovalBtn = true;   // Send to SAP hide
      }



      if (loginUserIsFranchisesRole() && i.Status === "Open") {
        i.forceMakeBtnHide = false

      }

      // ******** Make Invoice vs Make Challan (Sweet & Snacks) ********
      if (isSweetAndSnacksCompany && subPageMode === url.ORDER_LIST_4 && showChallanStatus) {
        i.forceMakeBtnHide = true;   // Hide Make Invoice
      }

      //***********************CHALLAN LOGIC ************************************************* */
      const systemSetting = loginSystemSetting();
      const showChallanOnSalesOrder = Number(systemSetting?.ShowChallanOnSalesOrder) === 1;

      // 1️⃣ Hide challan on Sales Order if setting is OFF
      if (
        !showChallanOnSalesOrder &&
        (subPageMode === url.ORDER_LIST_1 || subPageMode === url.ORDER_LIST_4)
      ) {
        i.forceMakeChallanHide = true;
      }

      // 2️⃣ Disable challan if already created
      if ((subPageMode === url.ORDER_LIST_1 && Inward === 1) || i.IsOrderClose || (subPageMode === url.ORDER_APPROVAL && i.IsAccountingApproved === true)) {
        i.ManuallyCloseDisabled = true
      } else {
        i.ManuallyCloseDisabled = false
      }
      if (i.ChallanCreated === true && i.IsOrderClose === true) {
        i.forceMakeChallanDisabled = true;
      } else {

        i.forceMakeChallanDisabled = false;
      }



      // 3️⃣ RA company + Advance Payment Party → disable Make Challan (Order List 4 only)
      if ((subPageMode === url.ORDER_LIST_4 && isRACompany() && ((i.ChallanCreated === true) || (i.IsAccountingApproved === false)))) {
        i.forceMakeChallanDisabled = true;
      }

      // if (!i.ISAdvancePaymentParty && i.IsConfirm && isRACompany()) {
      //   i.forceMakeChallanDisabled = false;
      // }

      // Advance Payment Party tag — inject directly into Customer cell HTML (Sales Order list only)
      if ((subPageMode === url.ORDER_LIST_4 || subPageMode === url.ORDER_APPROVAL) && i.ISAdvancePaymentParty === true && isRACompany()) {
        i.Customer = `${i.Customer}<div style="font-size:11px;font-weight:700;color:#0d6efd;letter-spacing:0.2px;margin-top:2px;">Advance Payment Party</div>`;
      }

      i.forceSendBtnDisabled = true;
      if (i.CBM_To_CSS_Mapping === true) {
        i.forceSendBtnDisabled = false;
        if (i.Send_CBM_to_CSS === true) {
          i.forceSendBtnDisabled = true;
          i.forceEditHide = true;
          i.forceDeleteHide = true;
        } else {
          i.forceSendBtnDisabled = false;
        }
      }

      if (i.IsAccountingApproved && !i.IsOrderClose) {
        i.forceMakeChallanDisabled = false;
      }
      // SAFE OVERRIDE
      if (showChallanStatus && (i.ChallanCreated == true)) {
        i.Status = "Challan Created";
      }

      if (i?.IsChildOrderFulfilled) {
        i.forceMakeChallanDisabled = true
      }

      if (i?.IsChildOrderOpen) {
        i.Status = "Open"
        i.forceMakeChallanDisabled = false;
      }

      if (i.IsOrderClose === true && subPageMode === url.ORDER_LIST_1 && isSweetAndSnacksCompany) {
        i.Status = "Close"
        i.forceEditHide = true;
        i.forceMakeBtnHide = true;
        i.forceDeleteHide = true
      }

      return i
    })

    if (subPageMode === url.ORDER_LIST_4) {
      newList = newList.filter(i => i.MobileAppOrderFlag === null);

      if (isRACompany()) {
        const hideOrderConfirm = getOrderVisibilitySetting().isPartyIncluded;
        if (hideOrderConfirm) {
          newList = newList.filter(i => i.IsAccountingApproved === true);
        }
      }
    } else if (subPageMode === url.APP_ORDER_LIST) {
      newList = newList.filter(i => i.MobileAppOrderFlag !== null);
    }
    else if (subPageMode === url.GRN_STP_1) {
      newList = newList.filter(i => i.Status === "Open");
    }
    else if (subPageMode === url.ORDER_LIST_1) {
      newList.forEach(order => {
        if (order.Status === "Close") {
          order.forceDeleteHide = true;
        }
      });

    } else if (subPageMode === url.GRN_STP_3) {
      newList = newList.filter(i => i.Inward !== "Close");
    } else if (subPageMode === url.ORDER_APPROVAL) {
      newList = newList.filter(i => i.IsConfirm === true);
    }
    yield put(getOrderListPageSuccess(newList))

  } catch (error) {
    yield put(orderApiErrorAction())
  }
}

function* orderApproval_GenFunc({ config }) {
  try {
    const response = yield call(orderApproval_Save_API, config)
    yield put(orderApprovalActionSuccess(response));
  } catch (error) {
    yield put(orderApiErrorAction())
  }
}


function* ManuallyOrderClose_GenFunc({ config }) {
  try {
    const response = yield call(ManuallyOrderClose_API, config)
    yield put(ManuallyOrderCloseSuccess(response));
  } catch (error) {
    yield put(orderApiErrorAction())
  }
}

function* getOrderApproval_Detail_GenFunc({ config }) {

  try {

    const response = yield call(OrderPage_Edit_Get_API, config)
    response.btnId = config.btnId

    yield put(getOrderApprovalDetailActionSucc(response));

  } catch (error) {
    yield put(getOrderApprovalDetailActionSucc({ Status: false }))
    yield put(orderApprovalActionSuccess({
      Status: true,
      Message: "Order Save Successfully But Can't Send in 'SAP'"
    }))
    yield put(orderApiErrorAction())
  }
}

function* OrderConfirm_GenFunc({ config }) {         // Update Order by subPageMode
  try {
    let response = yield call(OrderConfirm_post_API, config);
    response["conform_saveInvoice"] = config.conform_saveInvoice
    yield put(postOrderConfirms_API_Success(response))
  } catch (error) {
    yield put(orderApiErrorAction())
  }
}

function* OrderSingleGet_GenFunc({ config }) {

  try {
    let response = ""
    if (config.subPageMode === url.IB_ORDER_SO_LIST || config.subPageMode === url.IB_ORDER_PO_LIST) {
      response = yield call(IB_Order_Get_Api, config);
    } else {
      response = yield call(order_Single_and_Multiple_Print_API, config);

    }

    yield put(orderSinglegetSuccess(response))

  } catch (error) {
    yield put(orderApiErrorAction())
  }
}

function* OrderAccountingApproval_GenFunc({ config }) {
  try {
    const response = yield call(OrderAccountingApprovalAPI, config)
    yield put(orderAccountingApprovalActionSuccess(response));
  } catch (error) {
    yield put(orderApiErrorAction())
  }
}

function* OrderPageSaga() {

  yield takeLatest(MANUALLY_ORDER_CLOSE, ManuallyOrderClose_GenFunc);
  yield takeLatest(GO_BUTTON_FOR_ORDER_PAGE, goButtonGenFunc);
  yield takeLatest(SAVE_ORDER_FROM_ORDER_PAGE, saveOrder_GenFunc);
  yield takeLatest(EDIT_ORDER_FOR_ORDER_PAGE, editOrderGenFunc);
  yield takeLatest(UPDATE_ORDER_ID_FROM_ORDER_PAGE, UpdateOrder_ID_GenFunc)
  yield takeLatest(DELETE_ORDER_FOR_ORDER_PAGE, DeleteOrder_GenFunc);
  yield takeLatest(GET_ORDER_LIST_PAGE, orderList_GoBtn_GenFunc);
  yield takeLatest(ORDER_APPROVAL_ACTION, orderApproval_GenFunc);
  yield takeLatest(GET_ORDER_APPROVAL_DETAIL, getOrderApproval_Detail_GenFunc);
  yield takeLatest(POST_ORDER_CONFIRM_API, OrderConfirm_GenFunc);
  yield takeLatest(ORDER_ACCOUNTING_APPROVAL, OrderAccountingApproval_GenFunc);
  yield takeLatest(ORDER_SINGLE_GET_API, OrderSingleGet_GenFunc);
  yield takeLatest(ORDER_ITEMS, OrderItems_GenFunc);
  yield takeLatest(ADD_ORDER_ITEMS, AddOrderItems_GenFunc);

}

export default OrderPageSaga;

